import React from 'react';
import { useTranslation } from 'react-i18next';

import ModalLayout from "app/components/Layouts/ModalLayout/ModalLayout";

import styles from './styles.module.scss';

type PropsDef = {
  onConfirm: () => void;
  onClose: () => void;
  /** Family member the session is for (CN-1323); omitted for self-bookings. */
  participantName?: string;
  /**
   * True while the cancellation is in flight. The request takes ~2s when a refund is
   * involved and this modal stays up for all of it, so without this every further click
   * sent another DELETE (HB-133455570: five for one session). The coach's equivalent on
   * the calendar has had this since it was written.
   */
  loading?: boolean;
};

export default function CancelConfirmation(props: PropsDef) {
  const { onConfirm, onClose, participantName, loading = false } = props;
  const { t } = useTranslation();

  // ModalLayout dismisses on Escape and on an overlay click as well as through the X, so
  // every route out goes through here and none of them can drop a cancellation halfway.
  const handleClose = () => {
    if (loading) {
      return;
    }
    onClose();
  };

  return (
    <ModalLayout isOpen onClose={handleClose} classNames={`${styles.modal}`}>
      <div className={styles.confirmation_modal_content}>
        <div className={styles.close_button} onClick={handleClose}>
          <i className="ico ico-x" />
        </div>
        <div className={styles.title}>
          <i className={`ico ico-x ${styles.danger}`} />
          <h2>{t("Cancel Session")}</h2>
        </div>
        <div className={styles.content}>
          {participantName
            ? t(
                "Please confirm that you would like to cancel this session for {{name}}.",
                { name: participantName },
              )
            : t("Please confirm that you would like to cancel this session.")}
        </div>
        <div className={styles.actions}>
          <button
            type="button"
            className="btn btn-outline-secondary"
            data-testid="cancel-session-dismiss"
            onClick={handleClose}
            disabled={loading}
          >
            {t("Cancel")}
          </button>
          <button
            type="button"
            className={`btn ${styles.btn_danger}`}
            data-testid="cancel-session-confirm"
            onClick={onConfirm}
            disabled={loading}
            aria-busy={loading}
            aria-label={t("Confirm")}
          >
            {loading ? <span className={styles.spinner} aria-hidden="true" /> : t("Confirm")}
          </button>
        </div>
      </div>
    </ModalLayout>
  );
}
